import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

const hoc = (Comp, { mustBeSignedIn, redirectTo }) => {
  class C extends Component {
    componentWillMount() {
      this.handlePropChange(this.props)
    }
    componentWillUpdate(nextProps) {
      this.handlePropChange(nextProps)
    }
    handlePropChange(props) {
      if (!!props.user !== mustBeSignedIn) {
        props.history.push(redirectTo)
      }
    }
    render() {
      return <Comp {...this.props} />
    }
  }
  function mapStateToProps({ signin: { user } }) {
    return { user }
  }
  return withRouter(connect(mapStateToProps)(C))
}

export const requireToBeSignedIn = Comp =>
  hoc(Comp, { mustBeSignedIn: true, redirectTo: '/signin' })
export const requireNotToBeSignedIn = Comp =>
  hoc(Comp, { mustBeSignedIn: false, redirectTo: '/notes' })



// WEBPACK FOOTER //
// ./src/hoc/signinRequirement.js